<template>
  <div class="solution_bg_wrapper">
    <div class="solution_bg">
      <img :src="bgIntroData.bgSrc" alt="solution" />
    </div>
    <div class="solution_content">
      <div class="intro">
        <h3>{{ bgIntroData.title }}</h3>
        <p class="line"></p>
        <p class="intro_content">
          {{ bgIntroData.intro }}
        </p>

        <div class="download flex-start" v-if="showDownload">
          <img class="android" src="../../../assets/solution/android.svg" alt="android" />
          <span>+</span>
          <img class="ios" src="../../../assets/solution/ios.svg" alt="ios" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bgIntroData: {
      type: Object,
    },
    showDownload: {
      type: Boolean,
      default: true
    },
  },
};
</script>

<style lang="scss" scoped>
.solution_bg_wrapper {
  width: 100%;
  position: relative;
  .solution_bg {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    img {
      max-width: 100%;
    }
  }
  .solution_content {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    .intro {
      width: 50%;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      z-index: 2;
      h3 {
        margin-bottom: 30px;
        font-size: 28px;
        font-weight: 400;
        color: #ffffff;
      }
      .line {
        width: 50px;
        border-top: 2px solid #fff;
        margin-bottom: 45px;
      }
      .intro_content {
        font-size: 14px;
        font-weight: 300;
        color: #ffffff;
      }
      .download {
        margin-top: 40px;
        width: 100px;
        img{
          max-width: 25px;
          cursor: pointer;
        }
        span {
          font-size: 16px;
          color: #fff;
          font-weight: 300;
        }
      }
    }
  }
}
@media (max-width: 1600px) {
  .solution_bg_wrapper {
    height: 480px;
  }
  .solution_content {
    height: 480px;
  }
}
@media (min-width: 1601px) {
  .solution_bg_wrapper {
    height: 640px;
  }
  .solution_content {
    height: 640px;
  }
}
</style>